/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SatisfactionOverviewDetails = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        title: {
    type: 'string',
    isNullable: true,
},
        subTitle: {
    type: 'string',
    isNullable: true,
},
        totalMeet: {
    type: 'number',
},
        totalNotMet: {
    type: 'number',
},
    },
};